import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { FaRegCopy } from 'react-icons/fa';

import { copyToClipboard } from 'legacy/common/utils/clipboard';

const CopyToClipboard = ({ message, copyText }) => {
  const [showCopiedText, setShowCopiedText] = useState(false);

  return (
    <>
      {/* Desktop View */}
      <div className="hidden md:block">
        <div
          key={showCopiedText ? 'test' : 'test-hawa'}
          data-tip
          data-for={`copy-${copyText}`}
          className="flex items-center"
          onClick={() => {
            copyToClipboard(copyText);
            setShowCopiedText(true);
          }}
        >
          <a
            data-testid="copy-to-clipboard-text"
            className="text-xs md:text-sm text-primary-500 whitespace-nowrap"
          >
            {message}
          </a>
          <FaRegCopy className="ml-2 mb-1 text-primary-500 cursor-pointer" />
          <ReactTooltip
            id={`copy-${copyText}`}
            place="bottom"
            getContent={() =>
              showCopiedText ? 'Copied!' : 'Copy to Clipboard'
            }
            afterHide={() => {
              setShowCopiedText(false);
            }}
          />
        </div>
      </div>

      {/* Mobile View */}
      <div className="md:hidden">
        <div
          data-tip
          data-for={`copy-mobile-${copyText}`}
          className="flex items-center"
          onClick={() => {
            copyToClipboard(copyText);
            setShowCopiedText(true);
          }}
        >
          <a className="w-4/5 truncate text-sm md:text-sm text-primary-500">
            {message}
          </a>
          <div className="ml-2 p-2 border-1 border-primary-400 rounded ">
            <FaRegCopy className="text-primary-500 cursor-pointer" />
          </div>
          <ReactTooltip
            id={`copy-mobile-${copyText}`}
            place="bottom"
            delayHide={500}
            getContent={() =>
              showCopiedText ? 'Copied!' : 'Copy to Clipboard'
            }
            afterHide={() => setShowCopiedText(false)}
          />
        </div>
      </div>
    </>
  );
};

export default CopyToClipboard;
